import type {
  PlaybookId,
  PlaybookTree,
} from "@repo/app-types/entities/playbook";
import type {
  FeedbackWithCurrentGrade,
  RecordingAssessmentFeedbackStatus,
} from "@repo/app-types/entities/recordingAssessmentFeedback";
import { useOutletContext } from "react-router";
import type {
  PlaybookEditorData,
  UsePlaybookEditorResult,
} from "../hooks/usePlaybookEditor.js";
import type { PlaybookEditorContainerProps } from "./playbookEditorContainer.js";
import type { PlaybookEditorSelectionId } from "./playbookEditorUrlState.js";

export type EditorContainerRouteProps = Omit<
  PlaybookEditorContainerProps,
  "initialSelectedKey" | "onCurrentSelectionChange"
>;

export interface PlaybookEditorOutletContext {
  playbookIdParam: string;
  playbookId: PlaybookId | null;
  canReviewFeedback: boolean;
  data: PlaybookEditorData | undefined;
  liveTree: PlaybookTree | undefined;
  feedback: readonly FeedbackWithCurrentGrade[];
  isFeedbackLoading: boolean;
  isFeedbackError: boolean;
  showsKnowledgeBase: boolean;
  onChange: UsePlaybookEditorResult["onChange"];
  editorProps: EditorContainerRouteProps;
  onStableSelectionChange: (
    selectionId: PlaybookEditorSelectionId | null,
  ) => void;
  reviewStatus: RecordingAssessmentFeedbackStatus;
  onReviewStatusChange: (status: RecordingAssessmentFeedbackStatus) => void;
}

export function usePlaybookEditorOutletContext(): PlaybookEditorOutletContext {
  return useOutletContext<PlaybookEditorOutletContext>();
}
